<template>
    <div id="print" v-if="!isEmpty(listCourseQuestion)" class="question_content" @touchmove="touchmove" :style="{'background-color': '#275ba9'}">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>
        <input id="id_time_out" type="hidden" @click="resetShowGuide()">

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <!--拖拽题(上下结构)-->
        <div class="drop_updown_question_content">
            <input id="input_dpu_question_answer" type="hidden">
            <input id="input_dpu_answer" type="hidden" value="" />
            <div class="dpu_question_sty">
                <img id="dpu_question" :src="geneNetworkPicture(currentCourseQuestion.picture)" alt=""/>
                <!-- TODO 隐藏答案选项-->
            </div>
            <div id="dpu_answer" class="dpu_answer_sty">
                <div class="dpu_answer_content_sty">
                    <div :class="itemOption.isRightAnswer === 0 ? 'answer_error' : ''" :id="'dpu_drag_' + indexOption" v-drag3="{bgWidth: currentCourseQuestion.pictureWidthForCalcCoordinate,
                 optionWidth:clOptionWidth, json:JSON.stringify(currentCourseQuestion.optionArray), syncPlay:0}"
                         v-for="(itemOption,indexOption) in currentCourseQuestion.optionArray" :key="currentIndex + '_' + indexOption"
                         :style="{width:clOptionWidth + 'px', top: clOptionTop + 'px', left: (indexOption*(clOptionWidth + clOptionPadding) + 2*clOptionPadding) + 'px'}">
                        Stick picture and spring on the card
                    </div>
                </div>
            </div>
            <audio :src="dpuAudioUrl" id="dpu_musicMp3" style="display: none" @ended="dpu_playEnded" @error="dpu_playEnded" controls=""/>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vh - 60px)");
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
            $(".dp_question_sty img").css("height", "calc(100vw - 60px)");
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                currentIndex: 0,
                listCourseQuestion: [],
                currentCourseQuestion:{},
                dpuAudioUrl: "",
                clOptionWidth: 150,
                clOptionTop: 10,
                clOptionPadding: 10,
                showExitConfirm: 0,
            }
        },
        methods:{
            backNav:function(){
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            touchmove(e) {
                e.preventDefault();
            },
            getOptionWidth:function() {
                return 106;
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            dpu_playEnded() {
                var musicMp3 = document.getElementById('dpu_musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            resetShowGuide: function () {

            },
            dpuPlayEnded() {
            }
        },
        created() {
            window.resetShowGuide = this.resetShowGuide;
            window.clearGuideTimeout = this.clearGuideTimeout;
            window.successGetStar = this.successGetStar;
            window.successGetStarToNext = this.successGetStarToNext;
            window.dpuPlayEnded = this.dpuPlayEnded;

            this.$nextTick(() => {
                // 禁用右键
                document.oncontextmenu = new Function("event.returnValue=false");
                // 禁用选择
                document.onselectstart = new Function("event.returnValue=false");
            });
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "/bigCat6/getMindmapQuestion/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.listCourseQuestion = response.data;
                that.currentCourseQuestion = that.listCourseQuestion[this.currentIndex];
                that.lessonId = vLessonId;
                window.console.log(response.data);

                that.hideStatusAndStopAudio();

                // let type = that.currentCourseQuestion.type;
                //
                // if (type === 1) {
                //     that.cc_initAudioUrl();
                //
                //     setTimeout(() => {
                //         that.c_playCAudio();
                //     }, 200);
                // }

                setTimeout(() => {
                    transformView();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .question_content {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .back_nav img {
        width: 30px;
        height: 30px;
    }

    /*拖拽题（上下结构）*/
    .drop_updown_question_content .dpu_question_sty {
        position: absolute;
        width: 100%;
        text-align: center;
    }
    .drop_updown_question_content .dpu_question_sty img {
        height: auto;
        width: auto;
        max-width: calc(100vmax - 80px);
        max-height: 55vmin;
        margin-top: 20px;
    }
    .drop_updown_question_content .dpu_answer_sty {
        position: absolute;
        z-index: 990;
        display: flex;
        width: 100vmax;
        height: 20vmin;
        background-color: #333333;
        bottom: 0;
    }
    .drop_updown_question_content .dpu_answer_content_sty div {
        width: 120px;
        height: calc(20vmin - 20px);
        position:absolute;
        z-index: 997;
        display: flex;
        background-color: white;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        align-items: center;
        align-content: center;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        line-height: 18px;
    }
    .drop_updown_question_content .cl_next_question .next_question_c {
        margin-left: 20px;
        display: inline-block;
    }
    .drop_updown_question_content .cl_next_question .next_question_c span {
        display: inline-block;
        color: white;
        margin-right: 5px;
        font-weight: bold;
        vertical-align: middle;
    }
    .drop_updown_question_content .cl_next_question .next_question_c img {
        display: inline-block;
        width: 30px;
        height: 30px;
        vertical-align: middle;
    }

    .question_content .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .question_content .exit_content {
        position:relative;
    }
    .question_content .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .question_content .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .question_content .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .question_content .exit_content .game_action .game_quit img, .question_content .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .question_content .exit_content .game_action .game_quit span, .question_content .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }

</style>
